import React, { useContext } from "react";

import { GameState, ViewMode } from "../../components/shared/game-base/type";
import { GameContextModel } from "./game-context-type";

export const GameContext = React.createContext<GameContextModel>({
    roundId: 0,
    gameState: GameState.None,
    remainingTime: 0,
    totalBets: {},
    ownBets: {},
    gameSetting: null,
    gameConfigs: null,
    viewMode: ViewMode.full,
    playResultAnimation: false,
    isShowBlink: false,
    supportMD5: false,
    rate: 1,
});
GameContext.displayName = "GameContext";

export const GameContextProvider = GameContext.Provider;
export const GameContextConsumer = GameContext.Consumer;
export const useGameContext = () => useContext(GameContext);
